export const adminNotificationTypes = {
  "survey-approval": {
    label: "Survey Approval",
    filterLabel: "Approvals Only",
    action: { label: "Go to Surveys", target: "surveys", clearOnClick: false },
    describe: (d) => {
      const survey = d.surveyName ? `"${d.surveyName}"` : "a survey";
      const project = d.projectName ? ` for ${d.projectName}` : "";
      return d.submitterName
        ? `${d.submitterName} submitted ${survey}${project}.`
        : `${survey.charAt(0).toUpperCase()}${survey.slice(1)}${project} was submitted for approval.`;
    },
    fields: [
      { key: "surveyName", label: "Survey" },
      { key: "projectName", label: "Project" },
      { key: "submitterName", label: "By" },
    ],
  },

  "user-register": {
    label: "New Account",
    filterLabel: "Registrations Only",
    action: { label: "Go to Users", target: "users", clearOnClick: true },
    describe: (d) =>
      `${d.userName || "Someone"} created a new ${d.userRole || "user"} account.`,
    fields: [
      { key: "userName", label: "Name" },
      { key: "userEmail", label: "Email" },
      { key: "userRole", label: "Role" },
    ],
  },

  "project-created": {
    label: "New Project",
    filterLabel: "Projects Only",
    action: { label: "Go to Projects", target: "projects", clearOnClick: true },
    describe: (d) =>
      `${d.developerName || "A developer"} created the project "${d.projectName || "Untitled"}"${d.studioName ? ` under ${d.studioName}` : ""}.`,
    fields: [
      { key: "projectName", label: "Project" },
      { key: "studioName", label: "Studio" },
      { key: "developerName", label: "Developer" },
    ],
  },

  "new-message": {
    label: "New Message",
    filterLabel: "Messages Only",
    action: { label: "Open Messages", target: "messages", clearOnClick: true },
    describe: (d) => `${d.senderName || "Someone"} sent you a message.`,
    fields: [
      { key: "senderName", label: "From" },
    ],
  },

  "content-flagged": {
    label: "Flagged Content",
    describe: (d) =>
      `A ${(d.flaggedContext || "message").toLowerCase()} was blocked by moderation${d.flagReason ? ` (${d.flagReason})` : ""}.`,
    fields: [
      { key: "flagReason", label: "Reason" },
      { key: "flaggedContext", label: "Where" },
    ],
  },
};

export function getAdminNotificationType(type) {
  return adminNotificationTypes[type] || {
    label: "Notification",
    describe: () => "",
    fields: [],
  };
}

export function getNotificationAction(notification) {
  const config = getAdminNotificationType(notification.type);
  return config.action || null;
}

export function describeNotification(notification) {
  const config = getAdminNotificationType(notification.type);
  try {
    return config.describe(notification) || "";
  } catch (e) {
    return "";
  }
}

export function getAdminFilterLabels() {
  return ["All"].concat(
    Object.keys(adminNotificationTypes)
      .filter(key => adminNotificationTypes[key].filterLabel)
      .map(key => adminNotificationTypes[key].filterLabel)
  );
}

export function typeForFilterLabel(label) {
  return Object.keys(adminNotificationTypes).find(
    key => adminNotificationTypes[key].filterLabel === label
  );
}



// WEBPACK FOOTER //
// ./src/util/adminNotificationTypes.js